import React from 'react'

const OtherBusinessDetails = () => {
  return (
    <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full mx-auto">
    <h2 className="text-lg font-medium  mb-4 underline text-[#333333]">Other Business Details</h2>
    <table className="w-full ">
      <tbody>
        <tr className="">
          <td className="p-3 font-medium text-sm text-[#333333]">Tax ID:</td>
          <td className="p-3 text-sm text-[#333333]">TAX12345</td>
          <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Preferred Currency:</td>
          <td className="p-3 text-sm text-[#333333]">USD</td>
        </tr>
        <tr className=""> 
          <td className="p-3 font-medium text-sm text-[#333333]">Type of Company:</td>
          <td className="p-3 text-sm text-[#333333]">Owner</td>
          <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Year of Incorporation:</td>
          <td className="p-3 text-sm text-[#333333]">2016</td>
        </tr>
        <tr className="">
          <td className="p-3 font-medium text-sm text-[#333333]">Yearly Revenue:</td>
          <td className="p-3 text-sm text-[#333333]">10 to 50 million USD</td>
          <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">Number of Employees:</td>
          <td className="p-3 text-sm text-[#333333]">1 to 20</td>
        </tr>
        
      </tbody>
    </table>
  </div>
  )
}

export default OtherBusinessDetails